import { WalletMicrositeAnalyticsEvent } from '../index';
export var WalletMicrositeAnalyticsEventCardInfoScreenSaveClick = function (payload) { return ({
    type: WalletMicrositeAnalyticsEvent.CARD_INFO_SCREEN_SAVE_CLICK,
    payload: payload,
    eventName: 'Wallet_CardInfoScreen_Save_Click',
}); };
